export enum PlatformEnum {
  ios = 'ios',
  android = 'android',
  electron = 'electron',
  web = 'web',
}
